import { Component } from '@angular/core';
import { DatasheetService } from '../../Services/datasheet.service';
import { AuthService } from '../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoDataSheetsVM } from '../../Model/DtoDataSheetsVM';
import { environment } from '../../../environments/environment'
import { CustomToastrService } from '../../Shared/Services/custom-toastr.service';
import { Router } from '@angular/router';
import { DialogService } from '../../Shared/Services/dialog.service';
import { ShowImageComponent } from '../../Shared/Components/show-image/show-image.component';

@Component({
  selector: 'app-datasheet',
  templateUrl: './datasheet.component.html',
  styleUrl: './datasheet.component.scss'
})
export class DatasheetComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  imgPath: string = environment.ImgUrl;
  AllDataSheet!: DtoDataSheetsVM[];
  constructor(private api: DatasheetService, private auth: AuthService, private spinner: NgxSpinnerService,
    private toastrService: CustomToastrService, private router: Router, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.spinner.show();
      this.GetAllDataSheet();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllDataSheet() {
    if (this.auth.isAuthenticated()) {
      this.api.GetAllDataSheet()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.AllDataSheet = res.payload;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ShowImage(dataSheet?: any) {
    const data = { 'title': dataSheet.description, 'pathImage': this.imgPath + "/" + dataSheet.imagePath };
    this.dialogService.openDialog(ShowImageComponent, data);
  }
}
